// Module
var code = "<div ng-if=\"$ctrl.active\"> <div ng-transclude></div> </div> ";
// Exports
export default code;